module.exports = __webpack_public_path__ + "static/media/house-pin.7fe2d079.svg";